import { useEffect, useRef } from 'react';
import { Popup } from 'mapbox-gl';
import { MapEvents } from '@/hooks/useMap/useMap';
import { useMapContext } from '@/hooks/useMapContext/useMapContext';
export const MapBoxMarker = ({ lngLat, containerRef, }) => {
    const { map } = useMapContext();
    const popup = useRef(undefined);
    const removePopup = () => {
        if (popup.current) {
            popup.current.remove();
        }
    };
    useEffect(() => {
        if (!map || !containerRef.current)
            return;
        popup.current = new Popup({
            className: 'empty-popup',
            closeButton: false,
            closeOnClick: true,
        })
            .setLngLat(lngLat)
            .setDOMContent(containerRef.current)
            .addTo(map);
        map.on(MapEvents.REMOVE_POPUP, removePopup);
        return () => {
            map.off(MapEvents.REMOVE_POPUP, removePopup);
        };
    }, [map, lngLat, containerRef]);
    return null;
};
